import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Grid from "@material-ui/core/Grid";
import BankIcon from '../icons/BankIcon';
import InsuranceCompaniesIcon from '../icons/InsuranceCompaniesIcon';
import InvestorsIcon from '../icons/InvestorsIcon';
import CorporationsIcon from '../icons/CorporationsIcon';
import CloseIcon from '../icons/CloseIcon';
import translate from '../other/translate.json';
import IconButton from '@material-ui/core/IconButton';


export default function ChipsArray(props) {
	const classes = useStyles();
	let language = localStorage.getItem('language') || 'Ru'

	const chipData = [
		{ key: 5001, label: translate.Words[`labelBanks${language}`] },
		{ key: 5002, label: translate.Words[`labelStrah${language}`] },
		{ key: 5003, label: translate.Words[`labelInvest${language}`] },
		{ key: 5004, label: translate.Words[`labelCorp${language}`] },
	];


	// const handleDelete = (chipToDelete) => () => {
	// 	setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
	// };
	// const handleAdd = (chipToAdd) => () => {
	// 	// setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
	// };

	return (
		<Grid item lg={12} md={12} sm={12} component="ul" className={classes.root}>
			{chipData.map((data, ind) => {
				let icon;

				if (data.key === 5001) {
					icon = <BankIcon fill={Array.isArray(props.activeChips) && props.activeChips.includes(data.key) ? '#FFFFFF' : '#BCBBD0'} />;
				}

				if (data.key === 5002) {
					icon = <InsuranceCompaniesIcon fill={Array.isArray(props.activeChips) && props.activeChips.includes(data.key) ? '#FFFFFF' : '#BCBBD0'} />;
				}

				if (data.key === 5003) {
					icon = <InvestorsIcon fill={Array.isArray(props.activeChips) && props.activeChips.includes(data.key) ? '#FFFFFF' : '#BCBBD0'} />;
				}

				if (data.key === 5004) {
					icon = <CorporationsIcon fill={Array.isArray(props.activeChips) && props.activeChips.includes(data.key) ? '#FFFFFF' : '#BCBBD0'} />;
				}

				return (
					<li className={classes.li}>
						<Chip
							key={data.key + ind}
							icon={icon}
							label={data.label}
							style={{ backgroundColor: Array.isArray(props.activeChips) && props.activeChips.includes(data.key) ? '#EB505E' : '#FFFFFF' }}
							//onDelete={data.key === 1 ? undefined : () =>handleDelete(data)}
							// onDelete={Array.isArray(props.activeChips) && props.activeChips.includes(data.key)}
							// }

							onDelete={Array.isArray(props.activeChips) && props.activeChips.includes(data.key) ? () => props.checkActiveChips(data.key) : ''}

							className={
								clsx(classes.chip, {
									[classes.activeChip]: Array.isArray(props.activeChips) && props.activeChips.includes(data.key)
								})
							}
							onClick={Array.isArray(props.activeChips) && props.activeChips.includes(data.key) ? '' : () => props.checkActiveChips(data.key)}

							deleteIcon={
								<IconButton aria-label="delete" style={{ margin: 0 }}>
									<CloseIcon fill={'#FFFFFF'} />
								</IconButton>
							}
						/>
					</li>
				);
			})}
		</Grid>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		justifyContent: 'center',
		flexWrap: 'wrap',
		listStyle: 'none',
		color: '#F00',
		overflowX: 'auto',
		padding: '12px 0 !important',
		flexWrap: 'nowrap',

		[theme.breakpoints.down('lg')]: {
			justifyContent: 'left',
		}
	},

	chip: {
		margin: 0,
		padding: theme.spacing(2),
		backgroundColor: '#FFF',
		fontSize: 18,
		height: 56,
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 500,
		'& > span': {
			padding: '0 0 0 8px'
		},
	},

	activeChip: {
		margin: 0,
		padding: theme.spacing(2),
		backgroundColor: '#FFF',
		fontSize: 18,
		height: 56,
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 500,
		color: '#FFFFFF',
		'& > span': {
			padding: '0 0 0 8px'
		},
	},

	li: {
		margin: '0 9px',

		'&:first-child': {
			marginLeft: 0
		},

		'&:last-child': {
			marginRight: 0
		},
	}
}));